const ArrowLeft = (props) => (
  <svg fill='none' height={20} width={20} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      clipRule='evenodd'
      d='M12.442 4.558a.625.625 0 0 1 0 .884L7.884 10l4.558 4.558a.625.625 0 1 1-.884.884l-5-5a.625.625 0 0 1 0-.884l5-5a.625.625 0 0 1 .884 0Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default ArrowLeft;
